<button
  pButton
  pRipple
  type="button"
  [label]="languageKey.NEW | translateKey"
  icon="pi pi-plus"
  class="mr-2 ml-2"
></button>
